<template>
  <div class="drag-verify" :class="{ 'drag-verify-success': modelValue }" ref="dragVerify">
    <div class="drag-verify-t" :style="{ left: `${left}px` }" @mousedown="mousedownHandler" ref="dragVerifyT" :class="{ 'is-transition': isTransition }" @transitionend="isTransition = false"></div>

    <div class="drag-verify-c">请按住滑块，拖动到最右边</div>

    <div class="drag-verify-b" :style="{ width: `${left}px` }" :class="{ 'is-transition': isTransition }"></div>
  </div>
</template>

<script setup>
import { useFormItem } from "element-plus";
import { nextTick, watch } from "vue";
const { form, formItem } = useFormItem();

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});
const dragVerify = ref(null);
const dragVerifyT = ref(null);
const left = ref(0);
const isTransition = ref(false);
const isMousedown = ref(false);
const pageX = ref(0);
const emits = defineEmits(["update:modelValue"]);
const mousedownHandler = (e) => {
  if (props.modelValue || isTransition.value) {
    return;
  }

  pageX.value = e.pageX;
  isMousedown.value = true;
};

onMounted(() => {
  left.value = dragVerify.value.offsetWidth - dragVerifyT.value.offsetWidth;
  /*document.removeEventListener("mousemove", mousemove);

  document.addEventListener("mousemove", mousemove, false);

  document.addEventListener("mouseup", mouseup, false);

  function mousemove(e) {
    if (props.modelValue || !isMousedown.value || isTransition.value) {
      return;
    }

    let x = e.pageX - pageX.value;
    x = Math.max(0, x);
    x = Math.min(dragVerify.value.offsetWidth - dragVerifyT.value.offsetWidth, x);
    left.value = x;
  }

  function mouseup(e) {
    if (props.modelValue || !isMousedown.value || isTransition.value) {
      return;
    }

    isMousedown.value = false;
    if (left.value == dragVerify.value.offsetWidth - dragVerifyT.value.offsetWidth) {
      emits("update:modelValue", true);
    } else {
      emits("update:modelValue", false);

      isTransition.value = true;
      left.value = 0;
    }
  }*/
});

const reset = () => {
  left.value = 0;
  pageX.value = 0;
  isTransition.value = false;
  isMousedown.value = false;
  emits("update:modelValue", false);
};

defineExpose({
  reset,
});

watch(
  () => props.modelValue,
  (val) => {
    if (val) {
      left.value = dragVerify.value.offsetWidth - dragVerifyT.value.offsetWidth;
      emits("update:modelValue", true);
    } else {
      reset();
    }

    formItem?.validate?.("change");
  }
);
</script>

<style lang="scss" scoped>
.drag-verify {
  font-size: 12px;
  width: 100%;
  height: 40px;
  line-height: 40px;
  background-color: #eeeeee;
  user-select: none;
  text-align: center;

  &.drag-verify-success {
    .drag-verify-t {
      background: #fff
        url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAQCAMAAAAlM38UAAAAAXNSR0IArs4c6QAAALdQTFRFAAAAAP8AAICAAKqqAL+AM5lmM8yZJLZtHKpxLbR4K7iALrmDM7iFL7eFMLmGMLmEMbiCMbmCMLiDMbmDMLmEL7uEMbiDMLmEMLmDMbiDMbmEMLmFMbqFL7iEMbiEMLmFMbiDMLiDMbiEMLqEMbmDMbiDMLmDMbqEMbmEMLmEMLqEMLmEMbmEMLqEMbiEMLmEMLiDMLmEMbmDMLmDMbmEMbiDMbmEMbmEMbmEMLiEMLmEMbmEMbmExLCTVgAAADx0Uk5TAAECAwQFBQcJERIhMkdQW15iZWlqbHN0dXd4e32Bk5aWmpueoaKlpqiutLa9v83T2Njl8/T1+vv8/f3+iXf/gAAAAI1JREFUGBllwQUCglAUBMAFQcXubixssRD3/ufyfUxgBnHtk5tHTI+ki6guxQURTSp9hDWoDAAYxaqFt/qDYgQxI48ZBGoPirEGcSW5TUJUfApbg7KnsAGUfYqpjkDuTNFByaNY6Hgr3En6Q49imcBXix+OgT8Tvjgm/pkbKqsUwqwDyXUKUdndbZ7GzxOJCRtoOhP5QwAAAABJRU5ErkJggg==)
        no-repeat 50%;
    }
  }

  .is-transition {
    transition: all 0.3s ease;
  }

  .drag-verify-t {
    position: absolute;
    z-index: 2;
    height: 100%;
    left: 0;
    top: 0;
    box-sizing: border-box;
    width: 54px;
    border: 1px solid #dcdcdc;
    background: #ffffff
      url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAMAAACzQHQ9AAAAAXNSR0IArs4c6QAAAFFQTFRFAAAAgICAZmZmbW1tb29vbW1tcHBwcHBwbm5ucHBwbm5ub29vbm5ub29vcHBwbm5ub29vb29vb29vb29vb29vb29vbm5ubm5ub29vb29vb29vTz92QAAAABp0Uk5TAAQFBycqS1BRdHl6e3yAhIeoqq605Ofw+Pqazu8HAAAAVUlEQVQY023PWQ6AIAwE0EFxRdyqgr3/QU2MGJ3Qv76mG44BgA01nnA6AkbiC14noJDYEJxtgp6hu2ElMMsX5j9sWgHlHvJ16qf5tN9n03Q//8f/U1zqYQaVKXJuGwAAAABJRU5ErkJggg==)
      no-repeat 50%;
    // transition: all 0.3s ease;
  }

  .drag-verify-c {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  .drag-verify-b {
    width: 0%;
    height: 100%;
    background-color: #31b984;
    // transition: all 0.3s ease;
  }
}
</style>
